<template>
  <div
    class="toast-wrapper"
    v-if="show"
    :style="{ top: ToastWrapperTop }"
  >
    <div
      class="toast-container"
      :style="{
        backgroundColor: type === 'success' ? '#E6F9ED' : '#FCEDED',
        border: `1px solid ${type === 'success' ? '#407054' : '#A53535'}`,
      }"
    >
      <div
        class="toast-spike-outer"
        :style="{ borderBottomColor: type === 'success' ? '#407054' : '#A53535' }"
      ></div>
      <div
        class="toast-spike-inner"
        :style="{ borderBottomColor: type === 'success' ? '#E6F9ED' : '#FCEDED' }"
      ></div>
      <div
        class="toast-icon"
        :style="{ backgroundColor: type === 'success' ? '#407054' : '#A53535' }"
      >
        <svg
          class="toast-icon-svg"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="3"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            :d="type === 'success'
              ? 'M5 13l4 4L19 7'
              : 'M6 18L18 6M6 6l12 12'"
          />
        </svg>
      </div>
      <p
        class="toast-message"
        :style="{ color: type === 'success' ? '#181818' : '#7A1E1E' }"
      >
        {{ message }}
      </p>
      <button
        class="toast-close"
        :style="{ color: type === 'success' ? '#181818' : '#7A1E1E' }"
        @click="closeTooltip"
      >
        <svg
          class="toast-close-icon"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AddToCartToast",
  data() {
    return {
      ToastWrapperTop: "48px", // default for desktop
      mobileCutoff: "desktop",
      width: window.innerWidth,
    };
  },
  computed: {
    ...mapState("tgpt", ["show", "type", "message"]),
    cutoffPixels() {
      return this.cutoffToPixels(this.mobileCutoff);
    },
    isMobileLayout() {
      return !(this.width >= this.cutoffPixels);
    },
  },
  methods: {
    ...mapActions("tgpt", ["close"]),
    closeTooltip() {
      this.close();
    },
    updateToastTop() {
      if (this.isMobileLayout) {
        const bannerEl = document.getElementById("global-banner");
        const bannerHeight = bannerEl ? bannerEl.offsetHeight : 0;
        this.ToastWrapperTop = `${48 + bannerHeight}px`;
      } else {
        this.ToastWrapperTop = "48px"; // fallback for desktop
      }
    },
    cutoffToPixels(cutoff) {
      const cutoffs = {
          mobile: 0,
          tablet: 769,
          desktop: 1024,
          widescreen: 1216,
          fullhd: 1408,
      };
      if (typeof cutoff === "number") {
          return cutoff;
      } else if (cutoffs[cutoff]) {
          return cutoffs[cutoff];
      } else {
          return cutoffs.desktop;
      }
    },
  },
  mounted() {
    this.updateToastTop();
    window.addEventListener("resize", this.updateToastTop);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateToastTop);
  },
};
</script>
